import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Status } from "lib/enums";
import { ServerSettingsData } from "lib/types";
import { putServerSettings, ServerSettingsnUpdatePayload } from "./serverSettingsActions";
import { RootState } from "../../store";

type ServerSettingsDataState = {
    data: { [projectId: number]: { [siteId: number]: { [siteDesignId: number]: ServerSettingsData[] } } },
    statuses: { [projectId: number]: { [siteId: number]: Status } },
    serverSettingsStatus: Status
};

const initialState: ServerSettingsDataState = {
    data: {},
    statuses: {},
    serverSettingsStatus: Status.Idle,
};

const serverSettingsSlice = createSlice({
    name: 'serverSettings',
    initialState: initialState,
    reducers: {},
    extraReducers: builder => builder
        .addCase(putServerSettings.pending, state => {
            state.serverSettingsStatus = Status.Pending;
        })
        .addCase(putServerSettings.fulfilled, (state, action: PayloadAction<ServerSettingsnUpdatePayload>) => {
            state.serverSettingsStatus = Status.Success;
        })
        .addCase(putServerSettings.rejected, (state, action) => {
            state.serverSettingsStatus = Status.Rejected;
        })
});

export const selectServerSettingsLoading = (state: RootState): boolean => Object.values(state.serverSettingsStatus.statuses).some(status => status === Status.Pending)

export default serverSettingsSlice.reducer;